import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { htmlToText } from 'html-to-text';
import styled from 'styled-components';
export const RenderHtml = ({ html, className, }) => {
    if (!html) {
        return null;
    }
    return (_jsx(StyledProse, { className: className, children: _jsx("span", { dangerouslySetInnerHTML: { __html: html } }) }));
};
export const replaceWithHighlight = (text, highlight) => {
    return text === null || text === void 0 ? void 0 : text.replace(new RegExp(highlight, 'gi'), (match) => `<em>${match}</em>`);
};
export const RenderShortendedText = ({ html }) => {
    if (!html)
        return _jsx(_Fragment, {});
    const result = getShortenedText(htmlToText(html, {
        preserveNewlines: true,
        formatters: {
            anchor: (el, walk, builder) => {
                builder.openBlock();
                walk(el.children, builder);
                builder.closeBlock();
            },
        },
    }));
    return (_jsx(StyledProse, { children: _jsx("span", { children: result }) }));
};
const getShortenedText = (text) => {
    if (text.length <= 144)
        return text;
    return `${text.substring(0, 144)}…`;
};
const StyledProse = styled.span `
  p:not(:last-child) {
    margin-bottom: 1rem;
  }

  li {
    display: flex;
    padding-left: 0;
  }

  li::before {
    content: '•'; /* Manually add the bullet */
    margin-right: 6px; /* Space between bullet and text */
    font-size: 10px; /* Size of the bullet */
    line-height: 20px;
  }
`;
